// cpromo.js — versão: mostra "Copiado!" apenas no span ao lado do cupom
(function(){
  if (window.__cpromo_bound__) return;
  window.__cpromo_bound__ = true;

  function fallbackCopy(text){
    var ta=document.createElement('textarea');
    ta.value=text; ta.setAttribute('readonly','');
    ta.style.position='fixed'; ta.style.top='-1000px';
    document.body.appendChild(ta); ta.select();
    try{ document.execCommand('copy'); }catch(e){}
    document.body.removeChild(ta);
  }

  function copy(text){
    if (navigator.clipboard && navigator.clipboard.writeText){
      return navigator.clipboard.writeText(text).catch(function(){ fallbackCopy(text); });
    } else {
      fallbackCopy(text);
      return Promise.resolve();
    }
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('.mc-code');
    if (!btn) return;

    var root = btn.closest('.mc-root');
    if (!root) return;

    var code = (btn.getAttribute('data-code') || btn.textContent || '').trim();
    if (!code) return;

    // remove "copiado" de outros blocos antes de mostrar neste
    document.querySelectorAll('.mc-root.is-copied').forEach(function(el){
      if (el !== root) el.classList.remove('is-copied');
    });

    copy(code).then(function(){
      // mostra apenas o span "Copiado!" do bloco clicado
      root.classList.add('is-copied');

      // NÃO altera o texto do botão (evita duplicidade visual)
      setTimeout(function(){
        root.classList.remove('is-copied');
      }, 2000);
    });
  }, true);
})();
